module.exports = __webpack_public_path__ + "img/dps.2de3bc10.jpg";